module.exports = __webpack_public_path__ + "src/assets/img/logo.860d4b5c.png";